/**
 * Bağlantı adresi denetimi. Zengin metinde, menülerde, banner'larda ve sayfa bölümlerinde kullanılan her
 * adres buradan geçer. İzin verilenler: http(s) (kullanıcı adı/şifre içermeyen), mailto:, tel:, site içi
 * mutlak yol (`/urun/x`) ve sayfa içi çapa (`#bolum`). `javascript:`, `data:`, `//başka-site`, ters eğik
 * çizgi ve görünmez karakterlerle yapılan hileler reddedilir.
 */
export const MAX_HREF_LENGTH = 2048;

// Kontrol karakterleri, boşluklar, sıfır genişlikli ve yön değiştiren karakterler.
const UNSAFE_CHARS =
  // eslint-disable-next-line no-control-regex
  /[\u0000-\u0020\u007F-\u00A0\u00AD\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060-\u2064\uFEFF\\]/;

export function safeHref(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const href = raw.trim();
  if (!href || href.length > MAX_HREF_LENGTH || UNSAFE_CHARS.test(href)) return null;
  if (href.startsWith('/')) return href.startsWith('//') ? null : href;
  if (href.startsWith('#')) return href.length > 1 ? href : null;
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  switch (url.protocol) {
    case 'https:':
    case 'http:':
      if (!url.hostname || url.username || url.password) return null;
      return href;
    case 'mailto:':
    case 'tel:':
      return url.pathname.length > 0 ? href : null;
    default:
      return null;
  }
}

/** Sitenin dışına giden bağlantı mı (yeni sekme ve `rel` kararları için)? */
export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}
